export const downloadPdf = (fileURL, fileName, fileExt = "pdf") => {
      window.open(`${fileURL}`, '_blank')
};
